export default __webpack_public_path__ + "static/media/bank_vtb.06a0cd05.svg";